export default "__VITE_ASSET__BrZvKMJ3__"